import React from 'react';
import cx from 'classnames';

import { DefaultCellRendererContainer } from 'custom-table/js/components/DefaultCell';

/*
    This is a simple example of a custom cell renderer, just to show how we could override the default.
*/

const BoldCellRenderer = ( { className, value, ...additionalProps } ) => {
    return (
        <DefaultCellRendererContainer
            className={ cx( className, 'custom-table__cell--bold' ) }
            {...additionalProps}
        >
            <strong>{ value }</strong>
        </DefaultCellRendererContainer>
    );
}

export default BoldCellRenderer;
